import React from 'react';
import { Card as StandardCard } from '@emorg-prd/standard-react';
import './Cards.css';

export enum CardType {
	Blue = 'em-c-card--flat-lightblue',
	Default = 'em-c-card--bordered',
}

export type CardTypeType = 'blue' | 'default';

const typeMap: Record<CardTypeType, CardType> = {
	blue: CardType.Blue,
	default: CardType.Default,
};

interface CustomCardProps {
	kicker?: string;
	title: string;
	footer?: string;
	cardType?: CardTypeType;
	children?: React.ReactNode;
	onClick?: () => void;
	className?: string;
}

const Card: React.FC<CustomCardProps> = ({
	kicker,
	title,
	footer,
	cardType = 'default',
	children,
	onClick,
	className,
}) => {
	const mappedType = typeMap[cardType];

	return (
		<div 
			onClick={onClick} 
			className={`card-wrapper ${className || ''}`}
		>
			<StandardCard type={mappedType}>
				<div className="card-content-wrapper">
					{kicker && <div className="card-kicker">{kicker}</div>}
					<div className="card-title">{title}</div>
					<div className="card-body">
						{children}
					</div>
					{footer && <div className="card-footer">{footer}</div>}
				</div>
			</StandardCard>
		</div>
	);
};

// Card List component for rendering multiple cards
interface CardListProps {
	children: React.ReactNode;
	className?: string;
}

const CardList: React.FC<CardListProps> = ({ children, className }) => {
	return (
		<div className={`card-list ${className || ''}`}>
			{children}
		</div>
	);
};

export { Card, CardList };
